import { Component, OnInit,ViewEncapsulation  } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { BoxMessage } from '../../models/boxmessage';

@Component({
  selector: 'app-black-tlcd',
  templateUrl: './black-tlcd.component.html',
  styleUrls: ['./black-tlcd.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlackTLCDComponent extends BaseComponent implements OnInit {
	imggif:any;
	blackground:boolean = false;

	ngOnInit(): void {
		// super.ngOnInit();
		// this.imggif ='/assets/img/Foster-AnimationBox-01.gif?t=' + Date.now();

		var that = this;
		setTimeout(function(){
			// var msg = new BoxMessage('1','black_screen_ready');
  			// that.boxService.sendMessage(msg);
  			that.blackground = true;
		}, 5000);

		// var router = this.router;
	 //  	setTimeout(function(){
	 //  		router.navigate(['/Sanitization']);
	 //  	}, 6000);
	}
}
